import { Component, OnInit, ViewChild } from '@angular/core';
import { Descarga } from '../models/descarga';
import { MatPaginator, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import swal from 'sweetalert2';
import { NotificacaoService } from '../services/notificacao.service';
import { CarregandoService } from '../services/carregando.service';
import { DescargaService } from '../services/descarga.service';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-descarga',
  templateUrl: './descarga.component.html',
  styleUrls: ['./descarga.component.scss'],
})
export class DescargaComponent implements OnInit {
  descargasFiltradas: Descarga[];

  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  filtroDescricao = '';
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private router: Router,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private descargaService: DescargaService,
    private paginatorService: PaginatorService
  ) {}

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarDescargas();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarDescargas();
  }

  filtra() {
    this.buscarDescargas();
    this.paginator.firstPage();
  }

  buscarDescargas() {
    this.carregandoService.mostra('buscarDescargas');

    this.descargaService.consultarComPaginacao(
      this.filtroDescricao,
      this.paginacao.paginaAtual,
      this.itensPorPagina,
      this.campoOrdenacao,
      this.ordenarDesc ? 'desc' : 'asc',
    )
      .subscribe(
        (dados) => {
          this.descargasFiltradas = dados.itens;
          if (
            this.itensPorPagina >
            this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          ) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.carregandoService.esconde('buscarDescargas');
        },
        (erro) => {
          this.carregandoService.esconde('buscarDescargas');
          this.notificacaoService.erro(erro);
        }
      );
  }

  novaDescarga() {
    this.router.navigate(['/configuracoes/descarga/nova']);
  }

  editarDescarga(descarga) {
    this.router.navigate(['/configuracoes/descarga/editar', descarga.id]);
  }

  excluirDescarga(descarga: Descarga) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a Descarga?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirDescarga');
        this.descargaService.excluir(descarga.id).subscribe(resp => {
          this.notificacaoService.sucesso('Descarga excluída com sucesso!!!');
          this.carregandoService.esconde('excluirDescarga');
          this.filtra();
        }, (erro) => {
          this.carregandoService.esconde('excluirDescarga');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }
}